import React, { Fragment } from 'react';
import spinner from '../../img/spinner_gold.gif';

export default () => (
  <Fragment>
    <div className="container">
      <img
        src={spinner}
        style={{
          width: '100px',
          margin: 'auto',
          display: 'block',
          alignContent: 'center',
        }}
        alt="Loading..."
      />
    </div>
  </Fragment>
);
